import React, { useEffect, useState, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { useHistory, useParams, useRouteMatch } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { ResumePopupContext } from "../../../Context/resumePopupContext";
import SkeletonLoader from "../../SkeletonLoader/ResumeLoader";
import { jsonEditorContext } from "../../../Context/jsonEditorContext";
import AsyncSelect from "../../AsyncSelect/AsyncSelect";
import "./SampleContentModal.scss";
import {
  resumeEditActions,
  getResumeById,
  sampleResumeById,
} from "../../../Store/Actions/ResumeActions";
import { ResumeUpdateContext } from "../../../Context/resumeUpdateContext";
import { JsonEditorContextProvider } from "../../../Context/jsonEditorContext";
import SampleItem from "./SampleItem";
import LoginPopup from "../LoginPopup/LoginPopup";
import { templateGetParticularActions } from "../../../Store/Actions/TemplateActions";
//For update only redux
import { updateLocal } from "../../../Utils/updateLocalStorage";
import {
  EDITOR_DATA_ADD,
  EDITOR_DATA_RESET,
} from "../../../Store/Constants/EditorConstants";
import { changeLayout } from "../../../Store/Actions/LayoutActions";

function SampleResume(props) {
  const { resumeFields } = props;

  const dispatch = useDispatch();
  const { id } = useParams();
  const query = new URLSearchParams(window.location.search);
  const job = query.get("job");
  const path = window.location.pathname;
  const [showLogin, setShowLogin] = useState(false);

  const [selected, setSelected] = useState(0);
  const [content, setContent] = useState("");
  const [sampleJobTitle, setSampleJobTitle] = useState("");
  const [template, setTemplate] = useState("");
  const [clickedTemplate, setClickedTemplate] = useState({ id: 1 });
  const [initialTemplate, setInitialTemplate] = useState("");
  const { preview, setPreview } = useContext(ResumePopupContext);
  const [selectedValue, setSelectedValue] = useState("");
  const [rand, setRand] = useState(0);
  const [isChangeLayoutNeedSample, setIsChangeLayoutNeedSample] =
    useState(false);
  const [sampleContent, setSampleContent] = useState([]);
  const [sampleData, setSampleData] = useState();

  //Redux Store Values
  const templateData = useSelector((state) => state.templateList.list);

  const loadSampleData = useSelector((state) => state.sampleList.sample);
  const { resume } = useSelector((state) => state.resumeGetById);

  const {
    json,
    setJson,
    jsonIndex,
    setJsonIndex,
    isJson,
    setIsJson,
    isSample,
    setIsSample,
  } = useContext(jsonEditorContext);

  const chooseSample = (
    image,
    selectId,
    content,
    randomTemplate,
    res,
    isChangeLayoutNeed
  ) => {
    setSampleJobTitle(res.job_title);
    setSelected(selectId);
    setContent(content);
    setClickedTemplate(randomTemplate && randomTemplate);
    setSampleData(res);
    setIsChangeLayoutNeedSample(isChangeLayoutNeed);
  };

  const handleSampleContent = (type) => {
    let dateRange0 = {
      fromYear: 2018,
      fromMonth: "Mar",
      toYear: null,
      toMonth: null,
      isOnGoing: true,
      onGoingText: "Ongoing",
    };

    let dateRange1 = {
      fromYear: 2016,
      fromMonth: "Jan",
      toYear: 2017,
      toMonth: "Dec",
      isOnGoing: false,
      onGoingText: "Ongoing",
    };

    const user_settings = {
      job_title: sampleData && sampleData.job_title,
      job_category: sampleData && sampleData.category,
    };

    updateLocal(user_settings);

    if (path && path.includes("create")) {
      setIsSample(false);
      setPreview(false);
      setIsJson(false);
      let cont = JSON.parse(content);
      let data = { ...props.resumeFields };

      let experienceData = cont.experience.data;
      experienceData[0].dateRange = dateRange0;
      experienceData[1].dateRange = dateRange1;
      if (job && job != "") {
        data["profile"]["data"][0].jobTitle = job;
      }
      data["experience"]["data"] = experienceData;
      data["summary"]["data"] = cont.summary.data;
      data["skills"]["data"] = cont.skills.data;
      if (type && type != "template") {
        let layoutArray = data["layout"];
        let ArrayData = [[], []];
        ["lsbar", "rsbar"].map((position, index) => {
          layoutArray[index].map((data) => {
            let tempData = data;

            if (data.section == "experience") {
              tempData.itemIndexes = [0, 1];
            } else if (data.section == "skills") {
              tempData.itemIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
            }
            ArrayData[index].push(tempData);
          });
        });
        data["layout"] = ArrayData;
        dispatch({
          type: EDITOR_DATA_ADD,
          payload: data,
        });

        props.setResumeFields(data);
      }
      if (type && type == "template") {
        data["editorSettings"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.editorSettings;
        data["customization"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.customization;
        data["sectionPosition"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.sectionPosition;
        data["layout"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.layout;
        data.template_id = clickedTemplate && clickedTemplate.id;

        // For Premium Handle

        const checkLockedFeature =
          data["lockedFeatures"] === undefined ? false : true;
        if (!checkLockedFeature) {
          data["lockedFeatures"] = [];
        }
        const objWithIdIndex =
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].findIndex((obj) => obj === "template");
        // let res = { ...editorData }
        if (clickedTemplate && clickedTemplate.usage == "2") {
          if (objWithIdIndex === -1) {
            data["lockedFeatures"].push("template");
          }
        } else {
          if (
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].length > 0
          ) {
            if (objWithIdIndex > -1) {
              data &&
                data["lockedFeatures"] &&
                data["lockedFeatures"].splice(objWithIdIndex, 1);
            }
          }
        }

        dispatch(
          templateGetParticularActions(clickedTemplate && clickedTemplate.id)
        );
        dispatch(
          changeLayout(
            clickedTemplate &&
              clickedTemplate.settings &&
              clickedTemplate.settings.layout
          )
        );
        props.setResumeFields(data);
        dispatch({
          type: EDITOR_DATA_ADD,
          payload: data,
        });
      }
      dispatch(sampleResumeById(id, data, "isAuth"));
      hideSample(true);
    } else {
      setIsSample(false);
      setIsJson(false);
      setSelected(0);
      let cont = JSON.parse(content);
      let experienceData = cont.experience.data;
      experienceData[0].dateRange = dateRange0;
      experienceData[1].dateRange = dateRange1;

      let data = { ...props.resumeFields };

      //Hide for new template workflow use template only & use template & content
      // data["profile"]["data"][0].jobTitle = sampleJobTitle;
      // data["experience"]["data"] = experienceData;
      // data["summary"]["data"] = cont.summary.data;
      // data["skills"]["data"] = cont.skills.data;
      console.log(type, "type");
      if (type && type != "template") {
        data = cont;
        console.log(data, "datadatadatadatadata");
        data["profile"]["data"][0].jobTitle = sampleJobTitle;

        if (isChangeLayoutNeedSample) {
          const current_sectionPosition = data.sectionPosition;
          const current_layout = data.layout;
          let anotherSectionPosition =
            clickedTemplate &&
            clickedTemplate.settings &&
            clickedTemplate.settings.sectionPosition;
          let anotherLayout =
            clickedTemplate &&
            clickedTemplate.settings &&
            clickedTemplate.settings.layout;

          const combinedLsbarRsbar = [
            ...anotherSectionPosition.lsbar,
            ...anotherSectionPosition.rsbar,
          ]; // Combine lsbar and rsbar of anotherSectionPosition

          // Find missing sections for currentSection.lsbar and currentSection.rsbar
          const missingLsbar = current_sectionPosition.lsbar.filter(
            (section) => !combinedLsbarRsbar.includes(section)
          );
          const missingRsbar = current_sectionPosition.rsbar.filter(
            (section) => !combinedLsbarRsbar.includes(section)
          );

          // Combined array of missing sections (from both lsbar and rsbar)
          const missingSections = [...missingLsbar, ...missingRsbar];

          console.log("Missing Sections:", missingSections);

          // Step 2: Update or push new sections in anotherLayout
          missingSections.forEach((section) => {
            let sectionFound = false;
            console.log(section, "section");

            // Check if the section exists in currentLayout
            current_layout.forEach((layout, index) => {
              layout.forEach((item) => {
                if (item.section === section) {
                  sectionFound = true;

                  // Check if the section exists in the anotherLayout and update itemIndexes
                  anotherLayout[index].forEach((anotherItem) => {
                    if (anotherItem.section === section) {
                      anotherItem.itemIndexes = [
                        ...new Set([
                          ...anotherItem.itemIndexes,
                          ...item.itemIndexes,
                        ]),
                      ];
                    }
                  });

                  // If the section isn't found in the anotherLayout, push it
                  if (
                    !anotherLayout[index].some(
                      (item) => item.section === section
                    )
                  ) {
                    anotherLayout[index].push({
                      page: 0,
                      height: item.height, // Assuming height from currentLayout
                      section: section,
                      itemIndexes: item.itemIndexes,
                    });
                  }
                }
              });
            });

            if (
              data &&
              data.customization &&
              data.customization.grid_width &&
              data.customization.grid_width > 500
            ) {
              anotherSectionPosition.rsbar.push(section);
            } else {
              anotherSectionPosition.lsbar.push(section);
            }

            // If section not found in currentLayout, create a new layout entry
            if (!sectionFound) {
              if (
                data &&
                data.customization &&
                data.customization.grid_width &&
                data.customization.grid_width > 500
              ) {
                anotherLayout[1].push({
                  page: 0,
                  height: 120, // Default height or suitable value can be assigned
                  section: section,
                  itemIndexes: [0], // Assuming default itemIndex
                });
              } else {
                anotherLayout[0].push({
                  page: 0,
                  height: 120, // Default height or suitable value can be assigned
                  section: section,
                  itemIndexes: [0], // Assuming default itemIndex
                });
              }
            }
          });

          console.log(anotherLayout, "anotherLayout");
          console.log(anotherSectionPosition, "anotherSectionPosition");
          data["sectionPosition"] = anotherSectionPosition;
          data["layout"] = anotherLayout;
        }
        // let layoutArray = data["layout"];
        // let ArrayData = [[], []];
        // ["lsbar", "rsbar"].map((position, index) => {
        //   layoutArray[index].map((data) => {
        //     let tempData = data;

        //     if (data.section == "experience") {
        //       tempData.itemIndexes = [0, 1];
        //     } else if (data.section == "skills") {
        //       tempData.itemIndexes = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
        //     }
        //     ArrayData[index].push(tempData);
        //   });
        // });
        // data["layout"] = ArrayData;
      }
      if (type && type == "template") {
        const current_sectionPosition = data.sectionPosition;
        const current_layout = data.layout;
        let anotherSectionPosition =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.sectionPosition;
        let anotherLayout =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.layout;

        const combinedLsbarRsbar = [
          ...anotherSectionPosition.lsbar,
          ...anotherSectionPosition.rsbar,
        ]; // Combine lsbar and rsbar of anotherSectionPosition

        // Find missing sections for currentSection.lsbar and currentSection.rsbar
        const missingLsbar = current_sectionPosition.lsbar.filter(
          (section) => !combinedLsbarRsbar.includes(section)
        );
        const missingRsbar = current_sectionPosition.rsbar.filter(
          (section) => !combinedLsbarRsbar.includes(section)
        );

        // Combined array of missing sections (from both lsbar and rsbar)
        const missingSections = [...missingLsbar, ...missingRsbar];

        console.log("Missing Sections:", missingSections);

        // Step 2: Update or push new sections in anotherLayout
        missingSections.forEach((section) => {
          let sectionFound = false;
          console.log(section, "section");

          // Check if the section exists in currentLayout
          current_layout.forEach((layout, index) => {
            layout.forEach((item) => {
              if (item.section === section) {
                sectionFound = true;

                // Check if the section exists in the anotherLayout and update itemIndexes
                anotherLayout[index].forEach((anotherItem) => {
                  if (anotherItem.section === section) {
                    anotherItem.itemIndexes = [
                      ...new Set([
                        ...anotherItem.itemIndexes,
                        ...item.itemIndexes,
                      ]),
                    ];
                  }
                });

                // If the section isn't found in the anotherLayout, push it
                if (
                  !anotherLayout[index].some((item) => item.section === section)
                ) {
                  anotherLayout[index].push({
                    page: 0,
                    height: item.height, // Assuming height from currentLayout
                    section: section,
                    itemIndexes: item.itemIndexes,
                  });
                }
              }
            });
          });

          if (
            data &&
            data.customization &&
            data.customization.grid_width &&
            data.customization.grid_width > 500
          ) {
            anotherSectionPosition.rsbar.push(section);
          } else {
            anotherSectionPosition.lsbar.push(section);
          }

          // If section not found in currentLayout, create a new layout entry
          if (!sectionFound) {
            if (
              data &&
              data.customization &&
              data.customization.grid_width &&
              data.customization.grid_width > 500
            ) {
              anotherLayout[1].push({
                page: 0,
                height: 120, // Default height or suitable value can be assigned
                section: section,
                itemIndexes: [0], // Assuming default itemIndex
              });
            } else {
              anotherLayout[0].push({
                page: 0,
                height: 120, // Default height or suitable value can be assigned
                section: section,
                itemIndexes: [0], // Assuming default itemIndex
              });
            }
          }
        });

        console.log(anotherLayout, "anotherLayout");
        console.log(anotherSectionPosition, "anotherSectionPosition");

        data["editorSettings"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.editorSettings;
        data["customization"] =
          clickedTemplate &&
          clickedTemplate.settings &&
          clickedTemplate.settings.customization;
        data["sectionPosition"] = anotherSectionPosition;

        data["layout"] = anotherLayout;

        // For Premium Handle

        const checkLockedFeature =
          data["lockedFeatures"] === undefined ? false : true;
        if (!checkLockedFeature) {
          data["lockedFeatures"] = [];
        }
        const objWithIdIndex =
          data &&
          data["lockedFeatures"] &&
          data["lockedFeatures"].findIndex((obj) => obj === "template");
        // let res = { ...editorData }
        if (clickedTemplate && clickedTemplate.usage == "2") {
          if (objWithIdIndex === -1) {
            data["lockedFeatures"].push("template");
          }
        } else {
          if (
            data &&
            data["lockedFeatures"] &&
            data["lockedFeatures"].length > 0
          ) {
            if (objWithIdIndex > -1) {
              data &&
                data["lockedFeatures"] &&
                data["lockedFeatures"].splice(objWithIdIndex, 1);
            }
          }
        }
      }

      props.setRandLayout(1);
      dispatch({
        type: EDITOR_DATA_RESET,
        payload: {},
      });
      props.setResumeFields(data);
      const body = {
        title: resume && resume.title,
        body: "Body",
        content: JSON.stringify(data),
        completed: false,
        isLetter: resume && resume.isLetter,
        type: "resume",
        template_id: clickedTemplate && clickedTemplate.id,
        // template_id:
        //   type == "content"
        //     ? resume && resume.template_id
        //     : clickedTemplate && clickedTemplate.id,
      };
      dispatch(resumeEditActions(id, body)).then((response) => {
        setPreview(false);
        hideSample();
        dispatch(getResumeById(id)).then(() => {});
      });
    }
  };

  useEffect(() => {
    setSampleContent(
      loadSampleData && loadSampleData.data && loadSampleData.data
    );
    setContent(
      loadSampleData &&
        loadSampleData.data &&
        loadSampleData.data &&
        loadSampleData.data[0] &&
        loadSampleData.data[0].content
    );
    setSampleJobTitle(
      loadSampleData &&
        loadSampleData.data &&
        loadSampleData.data &&
        loadSampleData.data[0] &&
        loadSampleData.data[0].job_title
    );
    setSelected(
      loadSampleData &&
        loadSampleData.data &&
        loadSampleData.data &&
        loadSampleData.data[0] &&
        loadSampleData.data[0].id
    );
    if (rand && rand == 1 && initialTemplate && initialTemplate != "") {
      console.log(loadSampleData, "loadSampleData");
      console.log(initialTemplate, "initialTemplate");
      setClickedTemplate(initialTemplate);
      if (
        loadSampleData &&
        loadSampleData.data &&
        loadSampleData.data &&
        loadSampleData.data[0] &&
        loadSampleData.data[0].template_id >= 50
      ) {
        setIsChangeLayoutNeedSample(false);
      } else {
        setIsChangeLayoutNeedSample(true);
      }
    }
  }, [loadSampleData]);

  useEffect(() => {
    if (templateData && templateData.data && templateData.data.length > 0) {
      let tempArray = [];
      templateData &&
        templateData.data &&
        templateData.data
          .filter((data) => data.status == "1")
          .map((data, index) => {
            tempArray.push(data);
            if (index == 0) {
              setRand(1);
              setClickedTemplate(data);
              setInitialTemplate(data);
            }
          });

      setTemplate(tempArray);
    }
  }, [templateData]);

  const hideSample = () => {
    // setClickedTemplate(11);
    setClickedTemplate(initialTemplate);
    // setSelected(0);
    setIsSample(false);
    setPreview(false);
    setIsJson(false);
    props.hideSample(true);
  };

  useEffect(() => {
    if (props && props.showSample) {
      setIsSample(true);
      //   setIsJson(true);
    }
  }, [props.showSample]);

  const handleHide = () => {
    setShowLogin(false);
    setIsChangeLayoutNeedSample(false);
  };

  let i = 0;
  console.log(isChangeLayoutNeedSample, "isChangeLayoutNeedSample");
  return (
    <>
      <Modal
        className="sample-resume-modal "
        show={props.showSample}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onEscapeKeyDown={hideSample}
      >
        <Modal.Body className="sample-resume-modal-body">
          <LoginPopup show={showLogin} hide={handleHide} />
          <img
            onClick={() => hideSample()}
            src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
            alt="closeicon"
            className="close sample-resumepreview-smallclose"
          />

          <div className=" d-flex flex-wrap ">
            <div className="sampleresume-modal-listdiv">
              <div className="sample_img_section">
                <div>
                  <h4 style={{ color: "#ffffff" }}>Import a Resume Sample</h4>
                </div>
                <div className="frmgrp">
                  <span style={{ fontSize: "13px", color: "#ffffff" }}>
                    Job Title:
                  </span>
                  <AsyncSelect
                    setSelectedValue={setSelectedValue}
                    job={job}
                    modal={props.showSample}
                  />
                  {loadSampleData &&
                    !loadSampleData.success &&
                    loadSampleData &&
                    loadSampleData.message && (
                      <span className="error">
                        Job title not available choose another one
                      </span>
                    )}
                </div>
                <div className="sample_exp_select_div mt-3">
                  <div id="scrollableDiv" className="row sample-visual-div">
                    {sampleContent &&
                      template &&
                      template.length > 0 &&
                      sampleContent.map((res, index) => {
                        let image = res.thumb;
                        let template_id;
                        let isChangeLayoutNeed = false;

                        if (res.template_id >= 51) {
                          const foundTemplate = template.find(
                            (temp) => temp.id === res.template_id
                          );
                          if (foundTemplate) {
                            template_id = foundTemplate;
                            isChangeLayoutNeed = false;
                          } else {
                            isChangeLayoutNeed = true;
                            // Old flow if not found
                            let templateFromIndex = template && template[i];
                            template_id = templateFromIndex;
                            if (i >= template.length - 1) {
                              i = 0;
                            } else {
                              i++;
                            }
                          }
                        } else {
                          isChangeLayoutNeed = true;
                          // Old flow
                          let templateFromIndex = template && template[i];
                          template_id = templateFromIndex;
                          if (i >= template.length - 1) {
                            i = 0;
                          } else {
                            i++;
                          }
                        }

                        let template_image = JSON.parse(
                          template_id && template_id.image
                        );

                        return (
                          <>
                            <JsonEditorContextProvider>
                              <>
                                <div
                                  className="sample_img_modal_div cursor"
                                  style={{ position: "relative" }}
                                  onClick={() =>
                                    chooseSample(
                                      image,
                                      res.id,
                                      res.content,
                                      template_id,
                                      res,
                                      isChangeLayoutNeed
                                    )
                                  }
                                >
                                  <div style={{ pointerEvents: "none" }}>
                                    <div className="sample_img_modal ">
                                      <img
                                        className="template-image w-100"
                                        src={
                                          template_image && template_image.key
                                        }
                                      />
                                    </div>
                                  </div>

                                  <p
                                    style={{
                                      color: "#ffffff",
                                      fontSize: "14px",
                                    }}
                                  >
                                    {res.job_title1 &&
                                      res.job_title1
                                        .replace(/[\/'"]+/g, " ")
                                        .trim()}
                                    - (
                                    {res && res.experience
                                      ? res && res.experience
                                      : "0-2 Years"}
                                    )
                                  </p>
                                  <div className="mobile-resumepreview-edit">
                                    <button
                                      className="btn btn-success mb-2"
                                      onClick={() =>
                                        handleSampleContent("template")
                                      }
                                    >
                                      Use Template only
                                    </button>
                                    <button
                                      className="btn btn-success"
                                      onClick={() =>
                                        handleSampleContent("content")
                                      }
                                    >
                                      Use Template and content
                                    </button>
                                  </div>
                                  {selected === res.id ? (
                                    <div className="checkcircle-sample">
                                      <img
                                        src="/images/checkwhite.svg"
                                        alt="checkwhite"
                                      />
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                              </>
                            </JsonEditorContextProvider>
                          </>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>

            <div className="sampleresume-modal-previewdiv ">
              <div className="sample-selected-img-div">
                <div className="sample_preview_image">
                  <div>
                    {template &&
                    template.length > 0 &&
                    sampleContent &&
                    sampleContent ? (
                      sampleContent
                        .filter((res) => selected == res.id)
                        .map((res, index) => {
                          return (
                            <JsonEditorContextProvider>
                              <div key={res.id}>
                                <SampleItem
                                  resumedata={res.content}
                                  index={index}
                                  randomTemplate={clickedTemplate}
                                  full
                                  job_title={res.job_title}
                                  job_title1={res.job_title1}
                                  isChangeLayoutNeedSample={
                                    isChangeLayoutNeedSample
                                  }
                                />
                              </div>
                            </JsonEditorContextProvider>
                          );
                        })
                    ) : (
                      <div
                        style={{
                          width: "799px",
                          height: "1122px",
                          backgroundColor: "#fff",
                        }}
                      >
                        <SkeletonLoader count={5} />
                      </div>
                    )}
                  </div>

                  <div className=" sample-use-box">
                    <div className="row">
                      <div className="col-md-6">
                        <h5
                          className="card-title text-center "
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSampleContent("template")}
                        >
                          <i className="fas fa-check pr-3"></i>
                          Use template Only.
                        </h5>
                      </div>
                      <div className="col-md-6">
                        <h5
                          className="card-title text-center "
                          style={{ cursor: "pointer" }}
                          onClick={() => handleSampleContent("content")}
                        >
                          <i className="fas fa-check pr-3"></i>
                          Use Content & Template.
                        </h5>
                      </div>
                    </div>
                  </div>

                  <div className="close-div">
                    <img
                      src={`${process.env.REACT_APP_COMMON_ASSET_PATH}/close.svg`}
                      alt="closeicon"
                      className="sample-selected-close"
                      onClick={hideSample}
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default SampleResume;
